import * as ls from './localStorage';
import httpClient from './httpClient';
import config from '../globals/config'
const host = window.location.origin + "/firebase";

export const sendNotification = (
    eventId: string,
    senderUserId: string,
    recipients: [string],
    text: string,
    isSilent: boolean,
    poolId?: string | undefined, //PoolId expected when dealing with a non-MemberSuite push
    deeplinkingCategory?: "inbox" | "discover" | "moments",
    discoverCardPath?: string
) => {
    let body:any = {
        eventId,
        senderUserId,
        recipients,
        text,
        isSilent,
        isMemberSuite: false,
        poolId,

    };

    body = {...body, section:deeplinkingCategory, contentId:discoverCardPath}

    const config = {
        headers: {

            'User-ID': `${ls.getCCValues().CC_USER_ID}`,
        },
    };
    let endpointToUse;

    switch(deeplinkingCategory){

        default:
            endpointToUse = "sendNotification";
            break;

    }
    return httpClient.post(`${host}/${endpointToUse}`, body, config);
};
